import { render, staticRenderFns } from "./BackofficeOpme.vue?vue&type=template&id=4f1ce41f&scoped=true"
import script from "./BackofficeOpme.vue?vue&type=script&lang=ts"
export * from "./BackofficeOpme.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeOpme.vue?vue&type=style&index=0&id=4f1ce41f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1ce41f",
  null
  
)

export default component.exports